export enum ManufacturingItemEnum {
  Armado = 1,
  AccesorioLagune = 2,
  Equipamiento = 3,
  Deposito = 4,
  Revestimiento = 5,
  Combo = 6,
  Piscina = 7,
  Combinado = 8,
  Orientacion = 9,
  Lagune = 10,
  Calidad = 11,
  Spa = 12,
  AccesorioSpa = 13,
}
